import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

export const Logo = styled(Typography)``;
